import React, { useState } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// mui does not support a default TabPanel out of the box except in experimental lab package so create one from examples
import TabPanel from '../../components/TabPanel/TabPanel';

import PageHeader from "../../components/PageHeader/PageHeader";
import UsersTabPanel from './UsersTabPanel';
import UserSessionsTabPanel from './UserSessionsTabPanel';
import AlertSnackbar from '../../components/AlertSnackbar/AlertSnackbar';
import { hasPermission, usersManage } from '../../Utils/Common';

const Users = () => {
    
    const { permissions } = usePermissionContext();
    const [createUser, setCreateUser] = useState(false);

    const initialSnackbarState = {
        open: false,
        message: '',
        alertTitle: '',
        severity: 'info',
        hideDuration: 1000
    };

    const [notify, setNotify] = useState(
        initialSnackbarState
    );

    // define names of tabs
    const tabs = [
        {
            label: 'Users',
            value: 'users',
            component: <UsersTabPanel setNotify={setNotify} createUserOperation={createUser} setOpenUser={setCreateUser} />
        },
        {
            label: 'User Sessions',
            value: 'userSessions',
            component: <UserSessionsTabPanel setNotify={setNotify} />
        }
    ];

    let selectedIndex = sessionStorage.getItem("user") !== null ? sessionStorage.getItem("user") : 0
    const [value, setValue] = useState(+selectedIndex);    // set to previous visited connector schedule tab
    const [selectedTab, setSelectedTab] = useState(tabs[value].value);

    const hasUsersManage = hasPermission(permissions, usersManage);

    const handleChange = (event, newValue) => {
        sessionStorage.setItem("user", newValue)
        setSelectedTab(tabs[newValue].value);

        setValue(newValue);

        getPageHeader();       // needed??
    };

    const getPageHeader = () => {

        switch (selectedTab) {
            case 'users':
                return (<PageHeader title='Users' includeCreate={hasUsersManage} createTitle='Create User' onCreate={onCreateUser} />);  // if need create button
            case 'userSessions':
            default:
                return (<PageHeader title='Users' includeCreate={false} />);
        }
    };

    const onCreateUser = () => {
        setCreateUser(true);
    };

    return (
        <>

            <AlertSnackbar
                notify={notify}
                setNotify={setNotify} />

            {getPageHeader()}

            <Tabs value={value} onChange={handleChange} aria-label="user tabs">
                {tabs.map((tab) => <Tab key={`${tab.value}-tab`} id={`${tab.value}-tab`} label={tab.label} sx={{ textTransform: 'none' }} />)}
            </Tabs>

            {tabs.map((tab, index) => <TabPanel key={`${tab.value}-panel`} id={`${tab.value}-panel`} value={value} index={index}>{tab.component}</TabPanel>)}


        </>
    );

}

export default Users;